import React from "react";
import { Dialog } from "primereact/dialog";
import CustomeButton from "~/components/Button";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import PropTypes from "prop-types";
import "./new-request-modal.scss";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Chip } from "primereact/chip";
import successRequestIcon from "../../../../assets/images/successRequest.svg";
import { reasonTypes } from "./reasonTypes";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import useRequestModal from "./useRequestModal";
import { useNavigate } from "react-router-dom";
import FileUploadModal from "../../../../components/Processes/conversations/FileUploadModal";
import Attachments from "../../../../components/Processes/conversations/Attachments";
import { REQUEST_TYPES } from "../../useRequest";
import { InputText } from "primereact/inputtext";
import AttachmentConfirmationModal from "~/components/AttachmentConfirmationModal";
import { mergeCategories } from "./utils";
import { Tooltip } from "primereact/tooltip";
import {
  getAdHocEscalationDisplayName,
  resolveDisplayFileName,
} from "~/utils/fileUtils";

const NewRequestModal = ({
  showModal,
  setShowModal,
  hideRequestModal,
  refetch,
  requestType,
  parentTab = null,
}) => {
  const {
    reason,
    description,
    entity,
    setEntity,
    serviceLine,
    setServiceLine,
    assignee,
    setAssignee,
    cc,
    setCC,
    process,
    showClearConfirmation,
    setShowClearConfirmation,
    showSuccess,
    serviceLineData,
    ccRef,
    assigneeUsers,
    allEntities,
    ccUsersData,
    handleReasonChange,
    descriptionHandler,
    handleEntityChange,
    handleAssigneeChange,
    handleServiceLineChange,
    handleCCChange,
    handleCCRemove,
    handleAssigneeRemove,
    getInitials,
    requestId,
    isLoading,
    clear,
    handleClear,
    handleSendRequest,
    showUploadModal,
    setShowUploadModal,
    uploadFileHandler,
    fileSupported,
    getReason,
    files,
    onFileRemove,
    onUpdateVisibility,
    replaceFile,
    getFileSizeMB,
    config,
    showAttachmentConfirmation,
    setShowAttachmentConfirmation,
    selectedProcess,
    setSelectedProcess,
    handleProcessChange,
    allProcesses,
    getDeadlineDate,
    getSequenceNumber,
    payrollPlusProcess,
    setPayrollPlusProcess,
    isImplementationRequestEnabled,
    userRole,
  } = useRequestModal(hideRequestModal, requestType, parentTab);
  const serviceData = serviceLineData?.map((data) => data?.name) || [];
  const normalizedFiles = files.map((x, i) => {
    const fileObj = x.file;
    const period =
      fileObj?.fileYearMonth?.year && fileObj?.fileYearMonth?.month
        ? `${fileObj.fileYearMonth.year}-${String(fileObj.fileYearMonth.month).padStart(2, "0")}`
        : null;

    return {
      ...fileObj,
      name: fileObj?.fileName || fileObj?.name,
      category: fileObj?.category?.code || fileObj?.category,
      subCategory:
        fileObj?.subcategory?.code ||
        fileObj?.subcategory?.name ||
        fileObj?.subcategoryName ||
        fileObj?.subcategory ||
        fileObj?.subCategory ||
        fileObj?.subCategoryName,
      period,
      blob_url: fileObj?.blob_url || `${fileObj?.name}-${i}`,
    };
  });
  const displayNamesByIndex = normalizedFiles.map((file) =>
    resolveDisplayFileName(file, normalizedFiles),
  );

  const navigate = useNavigate();
  const attachmententity = entity ? entity : process?.entityData;
  const resolvedServiceLine = serviceLine?.name || process?.serviceData?.name;
  const isDisabled = !attachmententity || !resolvedServiceLine;

  const showCountryFlag = (name, country) => {
    return (
      <label className="selected-entity" htmlFor={name}>
        {`${name} (`}
        <div className="country-tag">
          <ReactCountryFlag countryCode={country} svg />
          <span style={{ textTransform: "capitalize", marginLeft: "7px" }}>
            {getName(country)}
          </span>
        </div>
        {")"}
      </label>
    );
  };

  const disabledEntityNameField = (entityData) => {
    return (
      <div className="p-inputtext p-component escalation-entity-container">
        <span className="country-tag">
          {entityData.name}
          {" ("}
          <ReactCountryFlag countryCode={entityData.country} svg />
          <span style={{ textTransform: "capitalize", marginLeft: "7px" }}>
            {getName(entityData.country)}
          </span>
          {")"}
        </span>
        <i className="pi pi-lock locked-field-icon" />
      </div>
    );
  };

  const resolveEscalation = () => {
    if (requestType === REQUEST_TYPES.ESCALATION) {
      if (parentTab !== REQUEST_TYPES.ESCALATION) {
        return !process?.name;
      } else {
        if (serviceLine?.name === "Payroll +") {
          return !payrollPlusProcess?.length;
        } else {
          return !selectedProcess?.displayName;
        }
      }
    } else {
      return false;
    }
  };
  const footer = (
    <div className="footer-btn-container">
      <div id="add-attachment-btn">
        <CustomeButton
          label="Add Attachments"
          variant="outlined"
          className="attachment-button p-button-outlined"
          icon="pi pi-paperclip"
          iconPos="right"
          disabled={isDisabled || resolveEscalation()}
          onClick={() => setShowUploadModal(true)}
        />
      </div>
      {(isDisabled || resolveEscalation()) && (
        <Tooltip
          target="#add-attachment-btn"
          content={
            requestType === REQUEST_TYPES.ESCALATION
              ? "Select an Entity, Service line and Process to attach files."
              : "Select an Entity and Service line to attach files."
          }
          position="right"
        />
      )}
      <CustomeButton
        label="Send"
        variant="contained"
        className="send-request-btn"
        icon="pi pi-send"
        iconPos="right"
        loading={isLoading}
        disabled={config.isSendButtonDisabled || isLoading}
        onClick={() => {
          if (files.length > 0) {
            hideRequestModal();
            setShowAttachmentConfirmation(true);
          } else {
            handleSendRequest();
          }
        }}
      />
    </div>
  );

  const cancelFooter = (
    <div className="footer-btn-container">
      <CustomeButton
        label={config.cancelBackButtonLabel}
        variant="outlined"
        className="attachment-button  p-button-outlined"
        onClick={() => {
          setShowClearConfirmation(false);
          setShowModal(true);
        }}
      />
      <CustomeButton
        label="Yes, Discard"
        variant="remove"
        className="send-request-btn"
        onClick={() => clear()}
      />
    </div>
  );

  const entityOptionsTemplate = (selectedEntity) => {
    return (
      <div className="flex align-items-center gap-2">
        <RadioButton
          checked={entity?.id === selectedEntity.id}
          onChange={() => setEntity(selectedEntity)}
        />
        <span>
          {showCountryFlag(selectedEntity.name, selectedEntity.country)}
        </span>
      </div>
    );
  };

  const entityValueTemplate = (selectedEntity, props) => {
    if (!selectedEntity) {
      return <span>{props.placeholder}</span>;
    }
    return (
      <span>
        {showCountryFlag(selectedEntity.name, selectedEntity.country)}
      </span>
    );
  };

  const serviceLineOptionsTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2">
        <RadioButton
          checked={serviceLine?.id === option.id}
          onChange={() => setServiceLine(option)}
        />
        <span>{option.name}</span>
      </div>
    );
  };

  const assigneeOptionsTemplate = (user) => {
    return (
      <div className="flex align-items-center gap-2">
        <RadioButton
          checked={assignee?.id === user.id}
          onChange={() => setAssignee(user)}
        />
        <span>
          {user.first_name} {user.last_name}
        </span>
      </div>
    );
  };

  const assigneeValueTemplate = (selectedUser, props) => {
    if (!selectedUser) {
      return <span>{props.placeholder}</span>;
    }

    const userFullName = `${selectedUser.first_name} ${selectedUser.last_name}`;
    return (
      <Chip
        className="assignee-chip"
        label={userFullName}
        image={selectedUser.profile_picture}
        icon={
          !selectedUser.profile_picture && (
            <span className="chip-profile-icon">
              {getInitials(userFullName)}
            </span>
          )
        }
        removable
        onRemove={handleAssigneeRemove}
      />
    );
  };

  const ccOptionsTemplate = (user) => {
    return (
      <div className="flex align-items-center gap-2">
        <span>
          {user.first_name} {user.last_name}
        </span>
      </div>
    );
  };

  const ccValueTemplate = (selectedUser) => {
    if (selectedUser) {
      const userFullName = `${selectedUser.first_name} ${selectedUser.last_name}`;
      return (
        <Chip
          key={selectedUser.id}
          className="assignee-chip"
          label={userFullName}
          image={selectedUser.profile_picture}
          icon={
            !selectedUser.profile_picture && (
              <span className="chip-profile-icon">
                {getInitials(userFullName)}
              </span>
            )
          }
          removable
          onRemove={() => handleCCRemove(selectedUser)}
        />
      );
    }
    if (!selectedUser) {
      return <span className="p-placeholder">{"Select Users"}</span>;
    }
  };

  const handleAddSelection = () => {
    setCC(cc);
    ccRef.current.hide();
  };

  const ccMultiselectFooter = (
    <div className="flex justify-content-between p-2 mx-2 border-top">
      <CustomeButton
        label="Deselect All"
        variant="outlined"
        onClick={() => setCC([])}
      />
      <CustomeButton
        label="Add Selection"
        variant="contained"
        className="access-btn"
        onClick={handleAddSelection}
      />
    </div>
  );

  const processOptionsTemplate = (process) => {
    return (
      <div className="flex align-items-center gap-2">
        <RadioButton
          inputId={process.id}
          name="process"
          value={process}
          onChange={(e) => {
            if (!e.value.isEscalated) {
              setSelectedProcess(e.value);
            }
          }}
          checked={!process.isEscalated && selectedProcess?.id === process.id}
          disabled={process.isEscalated}
        />
        <label htmlFor={process.id}>
          {`${process.name} ${getDeadlineDate(process)}${getSequenceNumber(process)} ${
            process.isEscalated ? "(already escalated)" : ""
          }`}
        </label>
      </div>
    );
  };

  const processValueTemplate = (selectedProcess, props) => {
    if (!selectedProcess) {
      return <span>{props.placeholder}</span>;
    }
    return (
      <span>
        {`${selectedProcess.name} ${getDeadlineDate(selectedProcess)}${getSequenceNumber(selectedProcess)}`}
      </span>
    );
  };

  const filterReasonTypes = reasonTypes.filter((data) => {
    if (data.code === "IMPLEMENTATION") {
      if (["GXM_ADMIN", "GXM_MANAGER", "GXM_USER"].includes(userRole)) {
        return isImplementationRequestEnabled;
      }
      return false;
    } else {
      return true;
    }
  });

  return (
    <>
      {!showClearConfirmation && !showSuccess ? (
        <Dialog
          header={
            <div>
              <div className="flex justify-content-between align-items-center">
                <span className="model-head">{config.modalHeader}</span>
                <i className="pi pi-times cross-icon" onClick={handleClear}></i>
              </div>
              <p className="model-description">{config.modalDescription}</p>
            </div>
          }
          visible={showModal}
          className="new-request-dialog"
          onHide={clear}
          footer={footer}
        >
          <div className="new-request-container">
            <div className="new-request-section">
              {requestType === REQUEST_TYPES.AD_HOC && (
                <div className="new-request-field-container">
                  <p className="reason-label">{"Reason *"}</p>
                  <Dropdown
                    value={reason}
                    onChange={(e) => handleReasonChange(e.value)}
                    options={filterReasonTypes}
                    optionLabel="name"
                    placeholder="Select Reason"
                    className="w-full reason-dropdown-btn"
                  />
                </div>
              )}
              <div className="new-request-field-container">
                <p className="description-label">
                  {config.descriptionFieldLabel}
                </p>
                <InputTextarea
                  value={description}
                  onChange={descriptionHandler}
                  placeholder="Help us understand what is happening and why you require support."
                  autoResize={true}
                  maxLength={4000}
                  counter={true}
                />
                <div className="description-label">
                  {description.length}/4000 characters allowed
                </div>
              </div>

              {files.length > 0 && (
                <div className="attachment-layout">
                  <h4>Attachments</h4>
                  <div className="attachment-container">
                    {files.map((file, index) => {
                      const f = file.file;
                      let displayDate = null;
                      if (f?.fileYearMonth?.year && f?.fileYearMonth?.month) {
                        displayDate = new Date(
                          f.fileYearMonth.year,
                          f.fileYearMonth.month - 1,
                          1,
                        );
                      }
                      const displayName =
                        resolvedServiceLine === "Payroll"
                          ? f?.name || f?.fileName
                          : displayNamesByIndex[index] ||
                            (typeof f?.subcategory === "object" &&
                            f?.subcategory?.name
                              ? getAdHocEscalationDisplayName(
                                  f.subcategory.name,
                                  displayDate,
                                  f.fileName || f.name,
                                )
                              : undefined);
                      return (
                        <Attachments
                          file={f}
                          key={index}
                          fileHandler={() => {
                            onFileRemove(file);
                          }}
                          icon="pi-times"
                          progressBar={isLoading}
                          error={file.error}
                          handleErrorVisibility={() => {
                            onUpdateVisibility(file);
                          }}
                          getFileSizeMB={getFileSizeMB}
                          displayName={displayName}
                          useUploadActions={true}
                          showRemoveIconInsteadOfDownload={true}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <div className="details-section">
              <p className="details-title">{config.detailsSectionHeader}</p>
              {(requestType === REQUEST_TYPES.AD_HOC ||
                parentTab === REQUEST_TYPES.ESCALATION) && (
                <div className="details-field-container">
                  <p className="entity-label">{"Entity *"}</p>
                  <Dropdown
                    value={entity}
                    onChange={(e) => handleEntityChange(e.value)}
                    options={allEntities}
                    optionLabel="name"
                    filter
                    placeholder="Select Entity"
                    className="dropdown-btn"
                    itemTemplate={entityOptionsTemplate}
                    valueTemplate={entityValueTemplate}
                  />
                </div>
              )}
              {requestType === REQUEST_TYPES.ESCALATION &&
                parentTab !== REQUEST_TYPES.ESCALATION && (
                  <div className="details-field-container">
                    <p className="entity-label">{"Entity *"}</p>
                    {process?.entityData &&
                      disabledEntityNameField(process.entityData)}
                  </div>
                )}
              {requestType === REQUEST_TYPES.ESCALATION &&
                parentTab !== REQUEST_TYPES.ESCALATION && (
                  <div className="details-field-container">
                    <p className="process-label">{"Service Line *"}</p>
                    <span className="p-input-icon-right">
                      <InputText
                        value={process?.serviceData?.name}
                        className="dropdown-btn"
                        readOnly
                      />
                      <i className="pi pi-lock locked-field-icon" />
                    </span>
                  </div>
                )}
              {requestType === REQUEST_TYPES.ESCALATION &&
                parentTab !== REQUEST_TYPES.ESCALATION && (
                  <div className="details-field-container">
                    <p className="process-label">{"Process *"}</p>
                    <span className="p-input-icon-right">
                      <InputText
                        value={`${process?.name} ${getDeadlineDate(process)}${getSequenceNumber(process)}`}
                        className="dropdown-btn"
                        readOnly
                      />
                      <i className="pi pi-lock locked-field-icon" />
                    </span>
                  </div>
                )}
              {(requestType === REQUEST_TYPES.AD_HOC ||
                parentTab === REQUEST_TYPES.ESCALATION) && (
                <div className="details-field-container">
                  <p className="service-line-label">{"Service Line *"}</p>
                  <Dropdown
                    value={serviceLine}
                    onChange={(e) => handleServiceLineChange(e.value)}
                    options={serviceLineData}
                    optionLabel="name"
                    placeholder="Select Service"
                    className="dropdown-btn"
                    itemTemplate={serviceLineOptionsTemplate}
                    disabled={
                      requestType === REQUEST_TYPES.AD_HOC
                        ? !(reason && entity)
                        : !entity
                    }
                  />
                </div>
              )}
              {parentTab === REQUEST_TYPES.ESCALATION &&
                serviceLine?.name !== "Payroll +" && (
                  <div className="details-field-container">
                    <p className="entity-label">{"Process *"}</p>
                    <Dropdown
                      value={selectedProcess}
                      onChange={(e) => handleProcessChange(e.value)}
                      options={allProcesses}
                      optionLabel="name"
                      filter
                      filterBy="displayName"
                      placeholder="Select Process"
                      className="dropdown-btn"
                      itemTemplate={processOptionsTemplate}
                      valueTemplate={processValueTemplate}
                      disabled={!(entity && serviceLine)}
                      optionDisabled={(option) => option.isEscalated}
                    />
                  </div>
                )}
              {parentTab === REQUEST_TYPES.ESCALATION &&
                serviceLine?.name === "Payroll +" && (
                  <div className="details-field-container">
                    <p className="entity-label">Process Name *</p>
                    <InputText
                      value={payrollPlusProcess}
                      placeholder="Enter Process Name"
                      onChange={(e) => setPayrollPlusProcess(e.target.value)}
                      className="dropdown-btn"
                    />
                  </div>
                )}
              <div className="details-field-container">
                <p className="assignee-label">{"Assignee *"}</p>
                <Dropdown
                  value={assignee}
                  onChange={(e) => handleAssigneeChange(e.value)}
                  options={assigneeUsers}
                  optionLabel="first_name"
                  filter
                  filterBy="first_name,last_name"
                  placeholder="Select Assignee"
                  className="dropdown-btn"
                  itemTemplate={assigneeOptionsTemplate}
                  valueTemplate={assigneeValueTemplate}
                  disabled={
                    !serviceLine &&
                    (requestType === REQUEST_TYPES.AD_HOC ||
                      parentTab === REQUEST_TYPES.ESCALATION)
                  }
                />
              </div>
              <div className="details-field-container">
                <p className="cc-label">{"CC"}</p>
                <MultiSelect
                  ref={ccRef}
                  value={cc}
                  options={ccUsersData}
                  onChange={(e) => handleCCChange(e.value)}
                  optionLabel="first_name"
                  filter
                  filterBy="first_name,last_name"
                  showSelectAll={false}
                  placeholder="Select Users"
                  className="dropdown-btn"
                  panelFooterTemplate={ccMultiselectFooter}
                  itemTemplate={ccOptionsTemplate}
                  selectedItemTemplate={ccValueTemplate}
                  display="chip"
                  disabled={
                    !serviceLine &&
                    (requestType === REQUEST_TYPES.AD_HOC ||
                      parentTab === REQUEST_TYPES.ESCALATION)
                  }
                />
              </div>
            </div>
          </div>
        </Dialog>
      ) : (
        <Dialog
          visible={showClearConfirmation}
          className="cancel-request-dialog"
          footer={cancelFooter}
        >
          <div>
            <div className="flex justify-content-between align-items-center">
              <span className="cancel-model-head">
                {config.cancelModalHeader}
              </span>
            </div>
            <p className="model-description">{config.cancelModalDescription}</p>
          </div>
        </Dialog>
      )}

      <Dialog
        visible={showSuccess}
        className="success-request-dialog"
        header={
          <div className="flex justify-content-end align-items-center">
            <i
              className="pi pi-times cross-icon"
              onClick={() => {
                clear();
                refetch();
              }}
            ></i>
          </div>
        }
        onHide={clear}
      >
        <div className="success-modal-description">
          <img src={successRequestIcon} />
          <div>
            <span className="success-model-head">
              {config.successModalHeader}
            </span>
          </div>
          <p className="model-description">{config.successModalDescription}</p>
        </div>
        <div className="footer-btn-container">
          {requestType === REQUEST_TYPES.AD_HOC && (
            <CustomeButton
              label="View Request"
              variant="outlined"
              className="attachment-button  p-button-outlined"
              onClick={() => navigate(`/requests/${requestId}/conversation`)}
            />
          )}
          <CustomeButton
            label="Done"
            variant="contained"
            className="send-request-btn"
            onClick={() => {
              clear();
              refetch();
            }}
          />
        </div>
      </Dialog>

      <FileUploadModal
        backButton={true}
        placeholder={"Drag & drop file here or click anywhere to choose file"}
        cancelButtonName={"Back"}
        entitydata={attachmententity}
        showModal={showUploadModal}
        fileSupported={fileSupported}
        hideUploadModal={() => setShowUploadModal(false)}
        setUploadedFile={uploadFileHandler}
        getService={getReason}
        relatedType={
          requestType === REQUEST_TYPES.AD_HOC ? "AD_HOC" : "ESCALATION"
        }
        uploadedFile={files}
        categories={mergeCategories(
          requestType === REQUEST_TYPES.ESCALATION
            ? serviceLine?.name
              ? [serviceLine?.name]
              : [process?.serviceData?.name]
            : [serviceLine?.name],
          userRole,
        )}
        serviceLineName={resolvedServiceLine}
      />

      <AttachmentConfirmationModal
        showModal={showAttachmentConfirmation}
        handleCloseModal={() => {
          setShowAttachmentConfirmation(false);
          setShowModal(true);
        }}
        handleConfirm={handleSendRequest}
        isLoading={isLoading}
      />
    </>
  );
};

NewRequestModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  hideRequestModal: PropTypes.func,
  refetch: PropTypes.func,
  requestType: PropTypes.string,
  parentTab: PropTypes.string,
};

export default NewRequestModal;
